export default "__VITE_ASSET__d6pnfmMb__"